export const home = {
  hero: {
    subtitle: 'ENGENHARIA PATRIMONIAL',
    title: 'FGT Capital — Rigor Técnico e Governança.',
    description: 'Arquitetura financeira para decisões patrimoniais via consórcios regulados. Método, modelagem e execução.'
  },
  manifesto: {
    line1: 'Patrimônio não se improvisa.',
    line2: 'Se projeta.',
    line3: 'Sem promessas. Com estrutura.'
  },
  pillars: {
    title: 'Nossos Pilares',
    engineering: {
      title: 'Engenharia',
      description: 'Modelagem técnica de cenários patrimoniais com análise estrutural de variáveis, regulamentos e dinâmicas de grupo.'
    },
    governance: {
      title: 'Governança',
      description: 'Transparência absoluta sobre riscos, prazos e custos. Sem promessas de contemplação ou retorno garantido.'
    },
    execution: {
      title: 'Execução',
      description: 'Acompanhamento disciplinado desde o diagnóstico até a utilização do crédito, com controle de cada etapa.'
    }
  },
  portfolio: {
    eyebrow: 'PORTFÓLIO',
    title: 'Portfólio',
    subtitle: 'Casos selecionados que representam o foco patrimonial e a capacidade técnica da FGT Capital.',
    secondaryNote: 'Além dos casos residenciais e automotivos em destaque, a FGT também estrutura demandas patrimoniais específicas em frentes complementares — imóveis corporativos, ativos de nicho e patrimônio de uso pessoal.',
    categories: {
      highlights: 'Destaques',
      residential: 'Residencial',
      automotive: 'Automotivo',
      corporate: 'Corporate',
      lifestyle: 'Estilo de Vida'
    },
    projects: [
      {
        id: 1,
        category: 'residential',
        featured: true,
        title: 'Penthouse Alphaville',
        location: 'Av. Ômega, 174 — Alphaville, Barueri, SP',
        value: 'R$ 3.450.000',
        creditRef: 'R$ 3.450.000',
        parcRef: 'R$ 17.805,00',
        prazoRef: '237 meses',
        condominioRef: 'R$ 3.577/mês',
        description: 'Estruturação patrimonial para aquisição de cobertura duplex em condomínio de alto padrão via consórcio imobiliário.',
        tags: ['Aquisição Patrimonial', 'Alto Padrão', 'Cobertura Duplex'],
        details: { area: '215m²', type: 'Cobertura Duplex' }
      },
      {
        id: 5,
        category: 'residential',
        featured: true,
        title: 'Apartamento Riviera de São Lourenço',
        location: 'Módulo 07 — Bertioga, SP',
        value: 'R$ 6.200.000',
        creditRef: 'R$ 6.200.000',
        parcRef: 'R$ 38.500,00',
        prazoRef: '200 meses',
        description: 'Engenharia patrimonial para aquisição de apartamento de alto padrão no litoral norte de São Paulo, com análise de sazonalidade e potencial locativo.',
        tags: ['Litoral', 'Segunda Residência', 'Alto Padrão'],
        details: { area: '141m²', type: 'Apartamento de Praia' }
      },
      {
        id: 13,
        category: 'residential',
        featured: true,
        title: 'Cobertura no Jardim Europa',
        location: 'Avenida Eusébio Matoso, 218 — Jardim Europa, São Paulo - SP',
        value: 'R$ 7.400.000',
        creditRef: 'R$ 7.400.000',
        parcRef: 'R$ 48.216,00',
        prazoRef: '200 meses',
        description: 'Cobertura de alto padrão na esquina da Av. Eusébio Matoso com a Av. Faria Lima — um dos endereços mais valorizados de São Paulo. 228m², 3 suítes e 5 vagas. Estruturação financeira via consórcio com curadoria patrimonial completa.',
        tags: ['Cobertura', 'Jardim Europa', 'Faria Lima'],
        details: { area: '228m²', bedrooms: '3 quartos / 3 suítes', parking: '5 vagas', type: 'Cobertura' }
      },
      {
        id: 14,
        category: 'residential',
        featured: true,
        title: 'Casa Condomínio Terras de São José',
        location: 'Itu, SP',
        value: 'R$ 6.500.000',
        creditRef: 'R$ 6.500.000,00',
        parcRef: 'R$ 40.250,00',
        prazoRef: '200 meses',
        description: 'Estruturação patrimonial para aquisição de residência em condomínio premium de interior, com análise de segunda residência, sazonalidade e potencial de valorização.',
        tags: ['Segunda Residência', 'Condomínio Premium', 'Interior Paulista'],
        details: { area: '369m²', type: 'Casa de Condomínio' }
      },
      {
        id: 16,
        category: 'residential',
        featured: true,
        title: 'Casa Condomínio Terras de São José 766m²',
        location: 'Itu, SP',
        value: 'R$ 12.000.000',
        creditRef: 'R$ 12.000.000,00',
        parcRef: 'R$ 76.860,00',
        prazoRef: '225 meses',
        description: 'Estruturação patrimonial para aquisição de casa de alto padrão no Condomínio Terras de São José, 3 quartos, 3 suítes, 40 vagas e 766m² de área privativa em Itu/SP.',
        tags: ['Condomínio Premium', 'Interior Paulista', 'Alto Padrão'],
        details: { area: '766m²', type: 'Casa de Condomínio' }
      },
      {
        id: 6,
        category: 'automotive',
        featured: true,
        title: 'BMW 320i GP 2026',
        location: 'São Paulo, SP',
        value: 'R$ 375.000,00',
        creditRef: 'R$ 375.000,00',
        parcRef: 'R$ 5.600,00',
        prazoRef: '78 meses',
        description: 'Sedan premium de alta performance, equipado com motor 2.0 Turbo (B48) de 184 cv e câmbio automático ZF de 8 marchas. Focado em tecnologia e sofisticação, traz o Curved Display (telas integradas), tração traseira, rodas de liga leve de 19” e recursos de condução semiautônoma como Park Assist e ACC.',
        tags: ['Veículo Premium', 'Eficiência de Capital', 'Estratégico'],
        details: { vehicleType: 'Sedan', type: 'Automóvel' }
      },
      {
        id: 10,
        category: 'residential',
        featured: false,
        title: 'Casa em Tamboré',
        location: 'Santana de Parnaíba, SP',
        value: 'R$ 3.800.000',
        creditRef: 'R$ 3.800.000',
        parcRef: 'R$ 47.500',
        prazoRef: '80 meses',
        description: 'Estruturação patrimonial para aquisição de casa em condomínio fechado de alto padrão em Tamboré, com análise de liquidez e preservação de capital.',
        tags: ['Condomínio Fechado', 'Localização Nobre', 'Preservação de Liquidez'],
        details: { area: '480m²', type: 'Casa em Condomínio', completion: '14 meses' }
      },
      {
        id: 11,
        category: 'residential',
        featured: false,
        title: 'Residência em Aldeia da Serra',
        location: 'Barueri, SP',
        value: 'R$ 5.200.000',
        creditRef: 'R$ 5.200.000',
        parcRef: 'R$ 65.000',
        prazoRef: '80 meses',
        description: 'Aquisição patrimonial em um dos condomínios mais valorizados do eixo Alphaville, com foco em sofisticação residencial e proteção de longo prazo.',
        tags: ['Alto Padrão', 'Exclusividade', 'Valorização'],
        details: { area: '620m²', type: 'Residência de Alto Padrão', completion: '18 meses' }
      },
      {
        id: 12,
        category: 'residential',
        featured: false,
        title: 'Apartamento em Moema Pássaros',
        location: 'São Paulo, SP',
        value: 'R$ 2.900.000',
        creditRef: 'R$ 2.900.000',
        parcRef: 'R$ 36.250',
        prazoRef: '80 meses',
        description: 'Estruturação de crédito para aquisição de apartamento de alto padrão em Moema, bairro nobre com liquidez consistente e perfil patrimonial consolidado.',
        tags: ['Localização Nobre', 'Liquidez', 'Sofisticação Residencial'],
        details: { area: '190m²', type: 'Apartamento', completion: '12 meses' }
      },
      {
        id: 15,
        category: 'residential',
        featured: false,
        title: 'Imóvel em Vila Nova Conceição',
        location: 'São Paulo, SP',
        value: 'R$ 4.300.000',
        creditRef: 'R$ 4.300.000',
        parcRef: 'R$ 53.750',
        prazoRef: '80 meses',
        description: 'Aquisição patrimonial em bairro nobre de São Paulo com alta liquidez histórica, perfil residencial consolidado e demanda permanente de alto padrão.',
        tags: ['Aquisição Patrimonial', 'Alta Liquidez', 'Localização Nobre'],
        details: { area: '260m²', type: 'Apartamento de Alto Padrão', completion: '16 meses' }
      },
      {
        id: 40,
        category: 'residential',
        featured: false,
        title: 'Casa em Condomínio no Jardim Marajoara',
        location: 'Jardim Marajoara, São Paulo/SP',
        value: 'R$ 2.530.000',
        creditRef: 'R$ 2.530.000',
        parcRef: 'R$ 35.000',
        prazoRef: '80 meses',
        condominioRef: 'R$ 1.484/mês',
        description: 'Estruturação patrimonial para aquisição de casa em condomínio com perfil familiar, metragem elevada e localização consolidada na zona sul de São Paulo.',
        tags: ['Aquisição Patrimonial', 'Alto Padrão', 'Casa em Condomínio'],
        details: { area: '380m²', type: 'Casa em Condomínio' }
      },
      {
        id: 41,
        category: 'residential',
        featured: false,
        title: 'Residência na Vila Sofia',
        location: 'Vila Sofia, São Paulo/SP',
        value: 'R$ 1.850.000',
        creditRef: 'R$ 1.850.000',
        parcRef: 'R$ 27.500',
        prazoRef: '80 meses',
        condominioRef: 'R$ 1.336/mês',
        iptuRef: 'R$ 298/mês',
        description: 'Aquisição patrimonial de residência em bairro residencial consolidado, com leitura de alto padrão urbano e vocação familiar.',
        tags: ['Residencial', 'Patrimônio Familiar', 'Localização Consolidada'],
        details: { area: '280m²', type: 'Residência Unifamiliar' }
      },
      {
        id: 42,
        category: 'residential',
        featured: false,
        title: 'Casa em Condomínio na Vila Sofia',
        location: 'Vila Sofia, São Paulo/SP',
        value: 'R$ 2.400.000',
        creditRef: 'R$ 2.400.000',
        parcRef: 'R$ 38.750',
        prazoRef: '80 meses',
        condominioRef: 'R$ 1.590/mês',
        description: 'Estruturação para aquisição de casa em condomínio com proposta residencial sofisticada, combinando privacidade, segurança e funcionalidade familiar.',
        tags: ['Aquisição Patrimonial', 'Alto Padrão', 'Casa em Condomínio'],
        details: { area: '420m²', type: 'Casa em Condomínio' }
      },
      {
        id: 43,
        category: 'residential',
        featured: false,
        title: 'Casa Familiar no Jardim Marajoara',
        location: 'Jardim Marajoara, São Paulo/SP',
        value: 'R$ 2.950.000',
        creditRef: 'R$ 2.950.000',
        parcRef: 'R$ 31.250',
        prazoRef: '80 meses',
        iptuRef: 'R$ 3.090/ano',
        description: 'Planejamento patrimonial para aquisição de casa ampla em região de perfil familiar e alto padrão residencial.',
        tags: ['Residencial', 'Patrimônio Familiar', 'Alto Padrão'],
        details: { area: '340m²', type: 'Casa Unifamiliar' }
      },
      {
        id: 44,
        category: 'residential',
        featured: false,
        title: 'Casa em Condomínio no Alto da Boa Vista',
        location: 'Alto da Boa Vista, São Paulo/SP',
        value: 'R$ 3.800.000',
        creditRef: 'R$ 3.800.000',
        parcRef: 'R$ 47.500',
        prazoRef: '80 meses',
        description: 'Aquisição patrimonial de residência em condomínio inserido em uma das regiões mais elegantes e consolidadas da zona sul de São Paulo.',
        tags: ['Aquisição Patrimonial', 'Alto Padrão', 'Casa em Condomínio'],
        details: { area: '460m²', type: 'Casa em Condomínio' }
      },
      {
        id: 2,
        category: 'corporate',
        featured: false,
        title: 'Sala Comercial Alphaville',
        location: 'Alameda Grajaú, 129 — Alphaville, Barueri — SP',
        value: 'R$ 3.000.000',
        creditRef: 'R$ 3.000.000',
        parcRef: 'R$ 15.830',
        prazoRef: '240 meses',
        condominioRef: 'R$ 4.251',
        description: 'Sala Comercial à venda no Ed. Murano Business Office em Alphaville/SP, área útil 200 m² com 4 vagas de garagens.',
        tags: ['Sala Comercial', 'Alphaville', 'Murano Business Office'],
        details: { area: '201m²', type: 'Sala Comercial', bathrooms: '4 banheiros', parking: '4 vagas' }
      },
      {
        id: 20,
        category: 'corporate',
        featured: false,
        title: 'Conjunto Médico Comercial — Vila Mariana',
        location: 'Rua Domingos De Morais, 2187 — Vila Mariana, São Paulo/SP',
        value: 'R$ 1.674.720',
        creditRef: 'R$ 1.674.720',
        parcRef: 'R$ 11.825,00',
        prazoRef: '225 meses',
        condominioRef: 'R$ 1.979',
        description: 'Conjunto de altíssimo padrão no Edifício Ez-Mark Vila Mariana, edifício contemporâneo ganhador de prêmio de arquitetura com projeto arquitetônico por Carlos Ott/DWA; paisagístico por Benedito Abbud e com decoração de Priscilla Zarzur. Alto padrão de acabamento com excelente utilização do espaço amplo e arejado com uma linda vista para o bairro. Localização espetacular ao lado do Shopping Metrô Santa Cruz, com acesso a linha azul do Metrô e a poucos minutos do eixo da Av. Paulista. Sobre o imóvel: Portaria 24 Horas com Segurança e Mensageria.',
        tags: ['Conjunto Médico', 'Vila Mariana', 'Ez-Mark'],
        details: { area: '104m²', type: 'Conjunto Médico Comercial', bathrooms: '1 banheiro', parking: '2 vagas' }
      },
      {
        id: 21,
        category: 'corporate',
        featured: false,
        title: 'Loja Comercial — Moema',
        location: 'São Paulo, SP',
        value: 'R$ 2.400.000',
        creditRef: 'R$ 2.400.000',
        parcRef: 'R$ 9.645,00',
        prazoRef: '240 meses',
        description: 'Conta com painéis fotovoltaicos, com área de descarga para facilitar o recebimento de mercadorias e materiais, na esquina da Al. Tupiniquins e a Praça dos Aranás, próximo da Av. Bandeirantes, Av. Ver. José Diniz, Av. Ibirapuela e corredor norte sul.',
        tags: ['Imóvel Comercial', 'Localização Nobre', 'Valorização'],
        details: { area: '320m²', type: 'Loja Comercial' }
      },
      {
        id: 22,
        category: 'corporate',
        featured: false,
        title: 'Sala Comercial — Av. Chucri Zaidan',
        location: 'São Paulo, SP',
        value: 'R$ 3.200.000',
        creditRef: 'R$ 3.200.000',
        parcRef: 'R$ 40.000',
        prazoRef: '80 meses',
        description: 'Aquisição de sala corporativa no corredor financeiro da Chucri Zaidan, com estruturação de crédito eficiente e análise de custo total da operação.',
        tags: ['Corporativo', 'Corredor Financeiro', 'Eficiência de Capital'],
        details: { area: '200m²', type: 'Sala Corporativa', completion: '20 meses' }
      },
      {
        id: 23,
        category: 'corporate',
        featured: false,
        title: 'Conjunto Comercial — Itaim Bibi',
        location: 'São Paulo, SP',
        value: 'R$ 4.600.000',
        creditRef: 'R$ 4.600.000',
        parcRef: 'R$ 57.500',
        prazoRef: '80 meses',
        description: 'Estruturação patrimonial para aquisição de conjunto corporativo no Itaim Bibi, um dos endereços empresariais mais valorizados de São Paulo.',
        tags: ['Conjunto Corporativo', 'Endereço Premium', 'Patrimônio Empresarial'],
        details: { area: '340m²', type: 'Conjunto Comercial', completion: '22 meses' }
      },
      {
        id: 24,
        category: 'corporate',
        featured: false,
        title: 'Sala Corporativa — Brooklin',
        location: 'São Paulo, SP',
        value: 'R$ 2.100.000',
        creditRef: 'R$ 2.100.000',
        parcRef: 'R$ 26.250',
        prazoRef: '80 meses',
        description: 'Engenharia financeira para aquisição de sala corporativa no Brooklin, com foco em preservação de caixa e eficiência no custo total de ocupação.',
        tags: ['Sede Própria', 'Fluxo Preservado', 'Estratégico'],
        details: { area: '150m²', type: 'Sala Corporativa', completion: '16 meses' }
      },
      {
        id: 25,
        category: 'corporate',
        featured: false,
        title: 'Consultório Premium — Moema Pássaros',
        location: 'São Paulo, SP',
        value: 'R$ 2.700.000',
        creditRef: 'R$ 2.700.000',
        parcRef: 'R$ 33.750',
        prazoRef: '80 meses',
        description: 'Aquisição patrimonial de consultório de alto padrão em Moema Pássaros, bairro nobre com perfil de clientela consolidado e liquidez histórica.',
        tags: ['Consultório Premium', 'Localização Nobre', 'Aquisição Patrimonial'],
        details: { area: '140m²', type: 'Consultório', completion: '18 meses' }
      },
      {
        id: 3,
        category: 'lifestyle',
        featured: false,
        title: 'BMW G 1300 GS',
        location: 'São Paulo, SP',
        value: 'R$ 140.000',
        creditRef: 'R$ 140.000',
        parcRef: 'R$ 1.390,00',
        prazoRef: '118 meses',
        description: 'A BMW R 1300 GS 2026 é a nova referência da marca no segmento trail, focada em redução de peso (-17 kg) e alto desempenho. Equipada com motor Boxer de 1.300 cc e 145 cv, destaca-se pelo novo quadro, suspensão EVO Telelever, tecnologia avançada (radar ACC) e design renovado.',
        tags: ['Motocicleta', 'Bem de Desejo', 'Consórcio'],
        details: { type: 'Motocicleta Adventure' }
      },
      {
        id: 4,
        category: 'lifestyle',
        featured: false,
        title: 'Road Bike',
        location: 'São Paulo, SP',
        value: 'R$ 65.000,00',
        creditRef: 'R$ 65.000,00',
        parcRef: 'R$ 1.200',
        prazoRef: '80 meses',
        description: 'Planejamento financeiro para aquisição de Road Bike Orbea Orca de alto desempenho, referência em performance e tecnologia ciclística de alto nível.',
        tags: ['Road Bike', 'Bem de Desejo', 'Consórcio'],
        details: { type: 'Road Bike' }
      },
      {
        id: 30,
        category: 'lifestyle',
        featured: false,
        title: 'Jet Ski — Moto Aquática',
        location: 'Brasil',
        value: 'R$ 85.000',
        creditRef: 'R$ 85.000',
        parcRef: 'R$ 1.100',
        prazoRef: '80 meses',
        description: 'Estruturação de crédito para aquisição de Jet Ski de alto desempenho, bem de uso e desfrute patrimonial com custo eficiente via consórcio.',
        tags: ['Jet Ski', 'Bem de Desejo', 'Lifestyle Aquático'],
        details: { area: '—', type: 'Jet Ski', completion: '10 meses' }
      }
    ]
  },
  methodology: {
    eyebrow: 'METODOLOGIA INTERATIVA',
    title: 'Da Análise à Execução',
    subtitle: 'Processo estruturado que garante rigor técnico em cada etapa da jornada patrimonial.',
    steps: [
      {
        number: '01',
        title: 'Diagnóstico Patrimonial',
        description: 'Mapeamento completo do perfil, objetivos e capacidade de investimento.',
        benefit: 'Para tomar decisões com base em dados reais, não em suposições.',
        details: 'Análise de renda, patrimônio atual, objetivos específicos e horizonte temporal.',
        icon: 'search'
      },
      {
        number: '02', 
        title: 'Análise Estrutural',
        description: 'Avaliação técnica de grupos, regulamentos e administradoras compatíveis.',
        benefit: 'Para conhecer as reais condições antes de qualquer comprometimento financeiro.',
        details: 'Estudo de regulamentos, histórico de grupos e análise de administradoras.',
        icon: 'analytics'
      },
      {
        number: '03',
        title: 'Modelagem de Cenários',
        description: 'Projeção de cenários base e stress test com variáveis de mercado.',
        benefit: 'Para visualizar os caminhos possíveis e planejar a aquisição com clareza.',
        details: 'Simulações Monte Carlo, análise de sensibilidade e cenários estressados.',
        icon: 'calculator'
      },
      {
        number: '04',
        title: 'Execução Controlada',
        description: 'Implementação com monitoramento contínuo até utilização do crédito.',
        benefit: 'Para que cada etapa ocorra dentro do planejado, sem surpresas operacionais.',
        details: 'Acompanhamento de assembleias, controle de prazos e gestão de riscos.',
        icon: 'checkmark'
      }
    ]
  },
  solutions: {
    title: 'Soluções',
    real_estate: {
      category: 'IMOBILIÁRIO',
      title: 'Aquisição Imobiliária',
      description: 'Estruturação de crédito para aquisição de imóveis residenciais e comerciais via consórcio regulado.'
    },
    construction: {
      category: 'CONSTRUÇÃO',
      title: 'Construção e Reforma',
      description: 'Planejamento financeiro para obras, reformas e ampliações com governança de desembolso.'
    },
    planning: {
      category: 'PLANEJAMENTO',
      title: 'Planejamento Patrimonial',
      description: 'Arquitetura de longo prazo para formação e proteção patrimonial com disciplina técnica.'
    },
    corporate: {
      category: 'EMPRESARIAL',
      title: 'Estruturação Empresarial',
      description: 'Soluções para aquisição de ativos, sede própria e expansão corporativa com método estruturado.'
    },
    letters: {
      category: 'CONTEMPLADAS',
      title: 'Cartas Contempladas',
      description: 'Curadoria técnica, validação documental e análise de risco operacional para cartas contempladas.'
    }
  },
  process: {
    title: 'Como Funciona',
    step1: {
      title: 'Diagnóstico',
      description: 'Mapeamento completo do perfil patrimonial, objetivos e capacidade de investimento do cliente.'
    },
    step2: {
      title: 'Análise Estrutural',
      description: 'Avaliação técnica de grupos, regulamentos e administradoras compatíveis com o perfil identificado.'
    },
    step3: {
      title: 'Modelagem de Cenários',
      description: 'Projeção de cenários base e stress test para visualização de riscos e oportunidades estruturais.'
    },
    step4: {
      title: 'Execução e Acompanhamento',
      description: 'Implementação da estratégia com monitoramento contínuo até a utilização completa do crédito.'
    }
  },
  governance: {
    text: 'Não há garantia de contemplação. Não há promessa de retorno fixo. A dinâmica depende do regulamento da administradora e da composição do grupo. Todas as variáveis são apresentadas com transparência técnica.'
  },
  finalCta: {
    title: 'Pronto para Estruturar seu Patrimônio?',
    description: 'Agendar um diagnóstico estratégico sem compromisso e entender como a engenharia patrimonial pode se aplicar ao seu caso.'
  },
  diagBanner: {
    eyebrow: 'DIAGNÓSTICO ESTRATÉGICO',
    title: 'Entenda seu potencial patrimonial em uma conversa.',
    description: 'Sem compromisso. Sem promessas. Apenas clareza técnica sobre o que o consórcio pode ou não fazer pelo seu caso.',
    item1: 'Análise personalizada do seu perfil',
    item2: 'Modelagem de cenários com dados reais',
    item3: 'Retorno em até 1 dia útil',
    cta: 'Agendar Diagnóstico Gratuito',
    disclaimer: 'Sem compromisso. Gratuito e confidencial.'
  },
  testimonials: {
    eyebrow: 'CASOS REAIS',
    title: 'O que nossos clientes dizem',
    subtitle: 'Relatos anônimos de clientes que passaram pelo processo de engenharia patrimonial.',
    items: [
      {
        quote: 'Eu tinha tentado financiamento duas vezes e não conseguia aprovação. A FGT mapeou meu perfil, modelou os cenários e estruturou uma entrada via consórcio que eu nunca teria pensado sozinho. Hoje tenho o imóvel.',
        profile: 'Empresário, 41 anos — São Paulo, SP',
        tag: 'Aquisição Imobiliária',
        credit: 'R$ 480.000'
      },
      {
        quote: 'O que me surpreendeu foi a transparência. Eles me mostraram exatamente os riscos, os prazos reais e os cenários de stress. Não houve promessa nenhuma — e isso me deu mais confiança do que qualquer garantia falsa.',
        profile: 'Médica, 38 anos — Belo Horizonte, MG',
        tag: 'Planejamento Patrimonial',
        credit: 'R$ 320.000'
      },
      {
        quote: 'Precisava de sede própria para a empresa sem comprometer o fluxo de caixa. A estruturação foi cirúrgica: consórcio empresarial com parcelas compatíveis com nossa receita. Resultado: sede quitada em 4 anos.',
        profile: 'Sócio-diretor, 47 anos — Campinas, SP',
        tag: 'Estruturação Empresarial',
        credit: 'R$ 1.200.000'
      },
      {
        quote: 'Queria construir, mas os juros do crédito imobiliário inviabilizavam o projeto. O diagnóstico mostrou que o consórcio de construção era a alternativa mais eficiente para o meu horizonte de 36 meses.',
        profile: 'Arquiteta, 34 anos — Florianópolis, SC',
        tag: 'Construção e Reforma',
        credit: 'R$ 260.000'
      },
      {
        quote: 'Recebi uma carta contemplada de terceiro e não sabia se era seguro. A FGT fez toda a validação documental e análise de risco antes de eu assinar qualquer coisa. Processo limpo, sem surpresas.',
        profile: 'Investidor, 55 anos — Rio de Janeiro, RJ',
        tag: 'Carta Contemplada',
        credit: 'R$ 750.000'
      },
      {
        quote: 'Três filhos, patrimônio disperso e sem planejamento. O diagnóstico foi o ponto de virada: entendi pela primeira vez como organizar e proteger o que construí em 20 anos de trabalho.',
        profile: 'Advogada, 52 anos — Curitiba, PR',
        tag: 'Planejamento Patrimonial',
        credit: 'R$ 900.000'
      }
    ],
    disclaimer: 'Depoimentos anônimos com dados alterados para preservar a privacidade dos clientes. Resultados individuais variam conforme perfil e condições de mercado.'
  },
  useCases: {
    eyebrow: 'CARTA CONTEMPLADA',
    title: 'Quando pode fazer sentido',
    subtitle: 'A carta contemplada é um instrumento específico, com vantagens e limitações técnicas. Entender quando ela é adequada ao seu objetivo é o primeiro passo de qualquer análise.',
    cta: 'Iniciar diagnóstico',
    items: [
      {
        label: 'Aquisição Imobiliária',
        title: 'Imóvel de alto padrão com menor custo total',
        description: 'Para quem busca crédito imobiliário significativo com custo total inferior ao financiamento tradicional, preservando liquidez no processo.'
      },
      {
        label: 'Veículo de Alto Padrão',
        title: 'Eficiência de capital na aquisição de veículos',
        description: 'Quando a relação custo-benefício importa mais do que a velocidade de aquisição — acesso ao crédito sem juros embutidos no contrato.'
      },
      {
        label: 'Crédito Pré-Contemplado',
        title: 'Estruturação patrimonial com acesso imediato',
        description: 'Cartas já contempladas oferecem crédito disponível agora, com análise de risco, validação documental e custo real projetado pela FGT.'
      },
      {
        label: 'Avaliação Comparativa',
        title: 'Antes de decidir entre as alternativas',
        description: 'Um diagnóstico técnico que revela o custo real de cada caminho: carta, consórcio ou financiamento, aplicado ao seu caso específico.'
      }
    ]
  },
  cartaCuration: {
    eyebrow: 'CURADORIA TÉCNICA',
    title: 'A FGT não vende uma carta.\nEla avalia, seleciona, estrutura e acompanha.',
    subtitle: 'Cada carta contemplada passa por um processo de análise rigoroso antes de qualquer recomendação ao cliente. O nosso trabalho começa muito antes da assinatura.',
    cta: 'Conhecer as cartas disponíveis',
    statement: 'A carta contemplada é um instrumento financeiro com regulamentação específica e riscos operacionais reais. Nossa curadoria existe para que o cliente acesse o instrumento certo, nas condições certas, com total clareza sobre o que está sendo contratado.',
    pillars: [
      {
        label: '01',
        title: 'Validação Documental',
        description: 'Verificamos procedência, regularidade e lastro de cada carta antes de qualquer recomendação formal.'
      },
      {
        label: '02',
        title: 'Análise de Fit ao Objetivo',
        description: 'Avaliamos se a carta é adequada ao objetivo patrimonial específico do cliente, evitando alocações inadequadas.'
      },
      {
        label: '03',
        title: 'Leitura de Custo e Risco',
        description: 'Comparamos o custo total efetivo da carta com as alternativas disponíveis no mercado, com transparência total.'
      },
      {
        label: '04',
        title: 'Revisão Operacional',
        description: 'Analisamos administradora, regulamento de grupo e condições de transferência antes de qualquer formalização.'
      },
      {
        label: '05',
        title: 'Acompanhamento Controlado',
        description: 'Monitoramos cada etapa até a utilização do crédito e regularização do bem, com relatórios periódicos.'
      }
    ]
  },
  intentPathways: {
    eyebrow: 'PONTO DE PARTIDA',
    title: 'Por onde começar',
    note: 'Cada diagnóstico é conduzido individualmente, sem compromisso. O objetivo é entender se a carta contemplada ou o consórcio regulado é o instrumento adequado para o seu caso.',
    items: [
      {
        label: 'Carta Contemplada',
        title: 'Quero avaliar uma carta contemplada',
        description: 'Recebo uma proposta ou quero entender se uma carta é a melhor alternativa para meu objetivo patrimonial.'
      },
      {
        label: 'Aquisição Imobiliária',
        title: 'Quero estruturar uma aquisição imobiliária',
        description: 'Busco a arquitetura financeira mais eficiente para adquirir um imóvel residencial ou comercial de alto padrão.'
      },
      {
        label: 'Comparativo de Alternativas',
        title: 'Quero comparar as alternativas de crédito',
        description: 'Preciso entender as diferenças reais entre carta contemplada, consórcio e financiamento para o meu caso específico.'
      },
      {
        label: 'Planejamento Patrimonial',
        title: 'Quero definir a melhor rota para meu patrimônio',
        description: 'Tenho objetivos patrimoniais de médio ou longo prazo e quero estruturá-los com método e governança.'
      }
    ]
  },
  comparative: {
    eyebrow: 'ANÁLISE TÉCNICA',
    title: 'Carta contemplada, consórcio ou financiamento?',
    subtitle: 'Cada estrutura tem lógica, custo e timing distintos. A escolha depende do objetivo, do horizonte e do perfil financeiro do cliente — não de preferência.',
    cta: 'Entender cartas contempladas',
    colDimension: 'Dimensão',
    colCarta: 'Carta Contemplada',
    colConsortium: 'Consórcio',
    colFinancing: 'Financiamento',
    disclaimer: 'Esta comparação é de natureza técnica e geral. As condições específicas variam conforme administradora, grupo, perfil e momento de mercado. O diagnóstico individual é necessário para uma avaliação precisa.',
    rows: [
      {
        dimension: 'Acesso ao Crédito',
        carta: 'Imediato — crédito já contemplado e disponível',
        consortium: 'Depende de lance ou sorteio',
        financing: 'Imediato, condicionado a aprovação'
      },
      {
        dimension: 'Custo Total',
        carta: 'Taxa de administração + ágio de mercado',
        consortium: 'Taxa de administração ao longo do grupo',
        financing: 'Juros compostos durante toda a operação'
      },
      {
        dimension: 'Flexibilidade',
        carta: 'Alta — uso do crédito sob controle do comprador',
        consortium: 'Restrita ao regulamento do grupo',
        financing: 'Vinculado ao bem financiado'
      },
      {
        dimension: 'Risco Principal',
        carta: 'Validação documental e procedência da carta',
        consortium: 'Incerteza de prazo para contemplação',
        financing: 'Custo financeiro elevado no longo prazo'
      },
      {
        dimension: 'Perfil Indicado',
        carta: 'Quem precisa de crédito agora com custo controlado',
        consortium: 'Quem tem horizonte flexível e disciplina de parcelas',
        financing: 'Quem prioriza velocidade e aceita o custo dos juros'
      }
    ]
  }
};